import { useForm } from 'antd/lib/form/Form'
import React, { FC, useEffect, useState } from 'react'
import ContactComponent from './components/ContactComponent'
import { useTranslation } from 'src/@legacy/@core/hooks/UserTranslation'
import { useClient } from 'src/@legacy/@core/hooks/useClient'
import { useCurrentCompany } from 'src/@legacy/@core/hooks/CurrentCompanyHooks'
import { useCurrentUser } from 'src/@legacy/@core/hooks/CurrentUserHooks'
import { API_URL_CONTACT_REQUEST, API_URL_CONTACT_REQUEST_LOGIN } from '../../@core/utilities/APIConstant'
import { notification } from 'src/@legacy/@core/components/share/ANTD/Notification'
import { useRecaptcha, verifyRecaptcha } from 'src/@legacy/@core/utilities/ReCaptcha'
import { useAppRouter } from 'src/@legacy/@core/hooks/UseAppRouter'

const ContactWrapper: FC = () => {
  const { translate, currentLanguage } = useTranslation()
  const [form] = useForm()
  const { client } = useClient()
  const [currentUser] = useCurrentUser()
  const [company] = useCurrentCompany()
  const profile = currentUser?.profile
  const [currentCompany, setCurrentCompany] = useState<any>()
  const [count, setCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const router = useAppRouter()
  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: translate('notification:submit_contact_form_success')
    })
  }
  const formData2Store = (values) => ({
    ...values,
    company_id: currentCompany?.id,
    locale: currentLanguage,
    user_id: currentUser?.profile?.id
  })
  const { loaded } = useRecaptcha()
  const onFinish = (data) => {
    setLoading(true)
    const params = formData2Store(data)
    return verifyRecaptcha(data, (isNotGoogleBOT) => {
      if (isNotGoogleBOT) {
        client
          .post(currentCompany?.data ? API_URL_CONTACT_REQUEST_LOGIN : API_URL_CONTACT_REQUEST, { sendUTM: true, data: params })
          .then(() => {
            openNotificationWithIcon('success')
            setLoading(true)
            setCount(30)
            router.push('/contact/success')
          })
      }
    })
  }

  useEffect(() => {
    if (company?.company) {
      setCurrentCompany(company.company)
      form.resetFields()
    }
  }, [company?.company])

  useEffect(() => {
    form.resetFields()
  }, [currentCompany])

  useEffect(() => {
    const countDown = setInterval(() => {
      if (count > 0) {
        setCount(count - 1)
      }
      if (count === 0) {
        setLoading(false)
      }
    }, 1000)
    return () => clearInterval(countDown)
  })

  return (
    <ContactComponent
      translate={translate}
      currentLanguage={currentLanguage}
      onFinish={onFinish}
      form={form}
      profile={profile}
      currentCompany={currentCompany}
      loading={loading}
      count={count}
    />
  )
}

export default ContactWrapper
